import { IStoryQuestionGroup } from "../model";

export const storyQuestionGroupInitialValues: IStoryQuestionGroup = {
  "id": 12,
  "active": true,
  "defaultTitle": "Hayalimdeki Kumsal",
  "storyId": 4,
  "organizationId": 1,
  "meditationId": null,
  "audioBookId": null,
  "showTypeId": 1,
  questionCount:0
};
